export default __webpack_public_path__ + "static/media/icon_trongnuoc.dcc3c6f6.svg";